import { IconButton } from '@dev-spendesk/grapes';

import { useTranslation } from 'common/hooks/useTranslation';

type Props = {
  onClose?: () => void;
  title: string;
  titleId: string;
};

export const SidePanelTitle = ({ onClose, title, titleId }: Props) => {
  const { t } = useTranslation('global');
  return (
    <div className="flex items-center gap-16">
      {onClose && (
        <IconButton
          iconName="arrow-left"
          variant="secondaryNeutral"
          onClick={onClose}
          hasNegativeMargins
          aria-label={t('misc.goBack')}
        />
      )}
      <span className="heading-xl" id={titleId}>
        {title}
      </span>
    </div>
  );
};
